// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"ZZ-z","subtitle":"_Z-z","wrapper":"a0-z","leftArrow":"b0-z","rightArrow":"c0-z"};